module.exports = __webpack_public_path__ + "c50677ca0f77b3bcff0aadc25a393d29.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-18.png
// module id = 2561
// module chunks = 0